import React from 'react'
import './whatGPT3.css'
import { Link } from 'react-router-dom';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3" id="wgpt3">
    <div className="gpt3__whatgpt3-heading">
      <h1 className="explore">Welcome to Our World</h1>
      {/* <p>view our recent project</p> */}
      <Link to="/work/annies-boutique">
        <p>View our recent project</p>
      </Link>
    </div>
  </div>
);

export default WhatGPT3;
